import React, { Component } from 'react'
import styled from 'styled-components'
import { responsiveDimension } from '../../../utils'
import { cloneDeep, isEmpty } from 'lodash'
import { inject, observer } from 'mobx-react'

@inject('GameStore')
@observer
export default class AnnouncementTimer extends Component {
  constructor(props) {
    super(props)
    this.sourcePlayData = cloneDeep(this.props.item)

    this.state = {
      timeLimitOptions: [],
      timerInput: 'unlimited',
      time_limit: null,
    }
  }

  setTimerInput() {
    if (this.props.item) {
      let play = this.props.item
      let { time_limit } = this.props.GameStore.sportType
      time_limit = time_limit['message']
        ? time_limit['message']['live_simulcast'] || null
        : null
      if (time_limit && play) {
        play.pmetadata = play.pmetadata
          ? typeof play.pmetadata !== 'object'
            ? JSON.parse(play.pmetadata)
            : play.pmetadata
          : {}
        let ddOptions = []
        if (time_limit['values']) {
          ddOptions = (time_limit['values'].split(',') || []).map(Number)
          ddOptions.push('unlimited')
        } else if (
          time_limit['range'] &&
          time_limit['range'][0] &&
          time_limit['range'][1]
        ) {
          const min = parseInt(time_limit['range'][0], 10),
            max = parseInt(time_limit['range'][1], 10)
          let i = min
          while (i < max) {
            ddOptions.push(i)
            i = i + parseInt(time_limit.interval, 10)
          }
          ddOptions.push(max)
          ddOptions.push('unlimited')
        }
        this.setState({
          time_limit: time_limit,
          timeLimitOptions: ddOptions,
          timerInput: !isEmpty(play.pmetadata)
            ? play.pmetadata.timerInput || 'unlimited'
            : time_limit.default || 'unlimited',
        })
      } else {
        this.setState({
          timeLimitOptions: ['unlimited'],
        })
      }
    }
  }

  handleTimerChange(updatedItem) {
    let hasChanges = false
    if (
      this.sourcePlayData &&
      this.sourcePlayData.pmetadata &&
      updatedItem &&
      updatedItem.pmetadata &&
      this.sourcePlayData.pmetadata.timerInput !==
        updatedItem.pmetadata.timerInput
    ) {
      hasChanges = true
      this.updatedItem = { ...this.props.item, ...updatedItem }
      this.props.item.pmetadata = updatedItem.pmetadata
    } else if (this.sourcePlayData && !this.sourcePlayData.pmetadata) {
      hasChanges = true
      this.updatedItem = { ...this.props.item, ...updatedItem }
      this.props.item.pmetadata = updatedItem.pmetadata
    } else {
      hasChanges = false
    }
    if (typeof this.props.isAnocHasChanges === 'function')
      this.props.isAnocHasChanges(hasChanges)
  }

  handleTimeLimitChange(e) {
    if (e && e.target) {
      const timerInput = parseInt(e.target.value || '', 10) || 'unlimited'
      this.setState({ timerInput })
      if (this.props.item) {
        let play = Object.assign({}, this.props.item)
        play.pmetadata = play.pmetadata || {}
        play.pmetadata.timerInput = timerInput
        this.handleTimerChange(play)
      }
    }
  }

  componentDidMount() {
    this.setTimerInput()
  }

  render() {
    const { timerInput, timeLimitOptions, time_limit } = this.state
    if (!time_limit) return null
    else
      return (
        <TimerInputWrapper>
          <TimerSelcetLabel>
            <span>{time_limit['unit']}</span>
          </TimerSelcetLabel>
          <TimerDDContainer height={this.props.height / 2.4}>
            <TimerSelect
              onChange={this.handleTimeLimitChange.bind(this)}
              fontWeight={timerInput === 'unlimited' ? 'bold' : ''}
            >
              {timeLimitOptions.map(option_value => {
                return option_value === 'unlimited' ? (
                  <option
                    value={option_value}
                    selected={option_value === timerInput}
                  >
                    ∞
                  </option>
                ) : (
                  <option
                    value={option_value}
                    selected={option_value === timerInput}
                  >
                    {option_value}
                  </option>
                )
              })}
            </TimerSelect>
          </TimerDDContainer>
        </TimerInputWrapper>
      )
  }
}

const FONT_SIZE = '1.8vh'

const TimerInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${responsiveDimension(1)};
  background-color: #000;
`

const TimerSelcetLabel = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  color: #fff;
  font-family: pamainregular;
  margin-left: ${responsiveDimension(0.1)};

  span:first-child {
    font-size: ${responsiveDimension(1.8)};
    line-height: 0.8;
  }

  span:last-child {
    font-size: ${responsiveDimension(1.5)};
    line-height: 0.8;
  }
`

const TimerDDContainer = styled.div`
  color: #fff;
  width: ${responsiveDimension(4)};
  height: ${props => props.height}vh;
  font-size: ${FONT_SIZE};
  display: ${props => (props.isDisabled ? 'none' : 'flex')};
`

const TimerSelect = styled.select`
  width: 100%;
  color: #000;
  font-family: pamainregular;
  font-weight: ${props => props.fontWeight || ''};
  font-size: ${responsiveDimension(2)};
  border: ${responsiveDimension(0.2)} solid #000;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/Common/AnnouncementTimer.js